export var TransactionType;
(function (TransactionType) {
    TransactionType[TransactionType["Transfer"] = 0] = "Transfer";
    TransactionType[TransactionType["CreateAsset"] = 1] = "CreateAsset";
    TransactionType[TransactionType["CreateValidator"] = 2] = "CreateValidator";
    TransactionType[TransactionType["ConfigValidator"] = 3] = "ConfigValidator";
    TransactionType[TransactionType["Freeze"] = 4] = "Freeze";
    TransactionType[TransactionType["Unfreeze"] = 5] = "Unfreeze";
    TransactionType[TransactionType["Delegate"] = 6] = "Delegate";
    TransactionType[TransactionType["Undelegate"] = 7] = "Undelegate";
    TransactionType[TransactionType["Withdraw"] = 8] = "Withdraw";
    TransactionType[TransactionType["Claim"] = 9] = "Claim";
    TransactionType[TransactionType["Unjail"] = 10] = "Unjail";
    TransactionType[TransactionType["AssetTrigger"] = 11] = "AssetTrigger";
    TransactionType[TransactionType["SetAccountName"] = 12] = "SetAccountName";
    TransactionType[TransactionType["Proposal"] = 13] = "Proposal";
    TransactionType[TransactionType["Votes"] = 14] = "Votes";
    TransactionType[TransactionType["ConfigITO"] = 15] = "ConfigITO";
    TransactionType[TransactionType["SetITOPrices"] = 16] = "SetITOPrices";
    TransactionType[TransactionType["BuyOrder"] = 17] = "BuyOrder";
    TransactionType[TransactionType["SellOrder"] = 18] = "SellOrder";
    TransactionType[TransactionType["CancelMarketOrder"] = 19] = "CancelMarketOrder";
    TransactionType[TransactionType["CreateMarketplace"] = 20] = "CreateMarketplace";
    TransactionType[TransactionType["ConfigMarketplace"] = 21] = "ConfigMarketplace";
    TransactionType[TransactionType["UpdateAccountPermission"] = 22] = "UpdateAccountPermission";
    TransactionType[TransactionType["Deposit"] = 23] = "Deposit";
    TransactionType[TransactionType["ITOTrigger"] = 24] = "ITOTrigger";
    TransactionType[TransactionType["SmartContract"] = 63] = "SmartContract";
})(TransactionType || (TransactionType = {}));
export var TriggerType;
(function (TriggerType) {
    TriggerType[TriggerType["Mint"] = 0] = "Mint";
    TriggerType[TriggerType["Burn"] = 1] = "Burn";
    TriggerType[TriggerType["Wipe"] = 2] = "Wipe";
    TriggerType[TriggerType["Pause"] = 3] = "Pause";
    TriggerType[TriggerType["Resume"] = 4] = "Resume";
    TriggerType[TriggerType["ChangeOwner"] = 5] = "ChangeOwner";
    TriggerType[TriggerType["AddRole"] = 6] = "AddRole";
    TriggerType[TriggerType["RemoveRole"] = 7] = "RemoveRole";
    TriggerType[TriggerType["UpdateMetadata"] = 8] = "UpdateMetadata";
    TriggerType[TriggerType["StopNFTMint"] = 9] = "StopNFTMint";
    TriggerType[TriggerType["UpdateLogo"] = 10] = "UpdateLogo";
    TriggerType[TriggerType["UpdateURIs"] = 11] = "UpdateURIs";
    TriggerType[TriggerType["ChangeRoyaltiesReceiver"] = 12] = "ChangeRoyaltiesReceiver";
    TriggerType[TriggerType["UpdateStaking"] = 13] = "UpdateStaking";
    TriggerType[TriggerType["UpdateRoyalties"] = 14] = "UpdateRoyalties";
    TriggerType[TriggerType["UpdateKDAFeePool"] = 15] = "UpdateKDAFeePool";
    TriggerType[TriggerType["StopRoyaltiesChange"] = 16] = "StopRoyaltiesChange";
    TriggerType[TriggerType["StopNFTMetadataChange"] = 17] = "StopNFTMetadataChange";
})(TriggerType || (TriggerType = {}));
export var ITOTriggerType;
(function (ITOTriggerType) {
    ITOTriggerType[ITOTriggerType["SetITOPrices"] = 0] = "SetITOPrices";
    ITOTriggerType[ITOTriggerType["UpdateStatus"] = 1] = "UpdateStatus";
    ITOTriggerType[ITOTriggerType["UpdateReceiverAddress"] = 2] = "UpdateReceiverAddress";
    ITOTriggerType[ITOTriggerType["UpdateMaxAmount"] = 3] = "UpdateMaxAmount";
    ITOTriggerType[ITOTriggerType["UpdateDefaultLimitPerAddress"] = 4] = "UpdateDefaultLimitPerAddress";
    ITOTriggerType[ITOTriggerType["UpdateTimes"] = 5] = "UpdateTimes";
    ITOTriggerType[ITOTriggerType["UpdateWhitelistStatus"] = 6] = "UpdateWhitelistStatus";
    ITOTriggerType[ITOTriggerType["AddToWhitelist"] = 7] = "AddToWhitelist";
    ITOTriggerType[ITOTriggerType["RemoveFromWhitelist"] = 8] = "RemoveFromWhitelist";
    ITOTriggerType[ITOTriggerType["UpdateWhitelistTimes"] = 9] = "UpdateWhitelistTimes";
})(ITOTriggerType || (ITOTriggerType = {}));
export var ParameterType;
(function (ParameterType) {
    ParameterType[ParameterType["FeePerDataByte"] = 0] = "FeePerDataByte";
    ParameterType[ParameterType["KAppFeeCreateValidator"] = 1] = "KAppFeeCreateValidator";
    ParameterType[ParameterType["KAppFeeCreateAsset"] = 2] = "KAppFeeCreateAsset";
    ParameterType[ParameterType["MaxEpochsUnclaimed"] = 3] = "MaxEpochsUnclaimed";
    ParameterType[ParameterType["MinSelfDelegatedAmount"] = 4] = "MinSelfDelegatedAmount";
    ParameterType[ParameterType["MinTotalDelegatedAmount"] = 5] = "MinTotalDelegatedAmount";
    ParameterType[ParameterType["BlockRewards"] = 6] = "BlockRewards";
    ParameterType[ParameterType["StakingRewards"] = 7] = "StakingRewards";
    ParameterType[ParameterType["KAppFeeTransfer"] = 8] = "KAppFeeTransfer";
    ParameterType[ParameterType["KAppFeeAssetTrigger"] = 9] = "KAppFeeAssetTrigger";
    ParameterType[ParameterType["KAppFeeValidatorConfig"] = 10] = "KAppFeeValidatorConfig";
    ParameterType[ParameterType["KAppFeeFreeze"] = 11] = "KAppFeeFreeze";
    ParameterType[ParameterType["KAppFeeUnfreeze"] = 12] = "KAppFeeUnfreeze";
    ParameterType[ParameterType["KAppFeeDelegate"] = 13] = "KAppFeeDelegate";
    ParameterType[ParameterType["KAppFeeUndelegate"] = 14] = "KAppFeeUndelegate";
    ParameterType[ParameterType["KAppFeeWithdraw"] = 15] = "KAppFeeWithdraw";
    ParameterType[ParameterType["KAppFeeClaim"] = 16] = "KAppFeeClaim";
    ParameterType[ParameterType["KAppFeeUnjail"] = 17] = "KAppFeeUnjail";
    ParameterType[ParameterType["KAppFeeSetAccountName"] = 18] = "KAppFeeSetAccountName";
    ParameterType[ParameterType["KAppFeeProposal"] = 19] = "KAppFeeProposal";
    ParameterType[ParameterType["KAppFeeVote"] = 20] = "KAppFeeVote";
    ParameterType[ParameterType["KAppFeeConfigITO"] = 21] = "KAppFeeConfigITO";
    ParameterType[ParameterType["KAppFeeSetITOPrices"] = 22] = "KAppFeeSetITOPrices";
    ParameterType[ParameterType["KAppFeeBuy"] = 23] = "KAppFeeBuy";
    ParameterType[ParameterType["KAppFeeSell"] = 24] = "KAppFeeSell";
    ParameterType[ParameterType["KAppFeeCancelMarketOrder"] = 25] = "KAppFeeCancelMarketOrder";
    ParameterType[ParameterType["KAppFeeCreateMarketplace"] = 26] = "KAppFeeCreateMarketplace";
    ParameterType[ParameterType["KAppFeeConfigMarketplace"] = 27] = "KAppFeeConfigMarketplace";
    ParameterType[ParameterType["KAppFeeUpdateAccountPermission"] = 28] = "KAppFeeUpdateAccountPermission";
    ParameterType[ParameterType["MaxNFTMintBatch"] = 29] = "MaxNFTMintBatch";
    ParameterType[ParameterType["MinKFIStakedToEnableProposals"] = 30] = "MinKFIStakedToEnableProposals";
    ParameterType[ParameterType["MinKLVBucketAmount"] = 31] = "MinKLVBucketAmount";
    ParameterType[ParameterType["MaxBucketSize"] = 32] = "MaxBucketSize";
    ParameterType[ParameterType["LeaderValidatorRewardsPercentage"] = 33] = "LeaderValidatorRewardsPercentage";
    ParameterType[ParameterType["ProposalMaxEpochsDuration"] = 34] = "ProposalMaxEpochsDuration";
})(ParameterType || (ParameterType = {}));
